export default __webpack_public_path__ + "static/media/Malecifent-Glass.91248e73.jpg";